var _rect, _rect2, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsuranceScore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#D6FFDA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#CFFFF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7414 27.8966C35.0249 28.0856 35.4031 28.0856 35.6866 27.8966C37.8291 26.3527 42.5238 23.139 42.5238 19.1375C42.5238 16.9634 40.7594 15.2305 38.6168 15.2305C37.1673 15.2305 35.9071 16.0182 35.214 17.1839C34.521 16.0182 33.2605 15.2305 31.8113 15.2305C29.6372 15.2305 27.9043 16.9948 27.9043 19.1375C27.9043 23.1388 32.5673 26.3842 34.7414 27.8966Z",
    fill: "url(#paint0_linear_423_400)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3611 40.2127C15.1404 40.5279 15.2035 40.969 15.5187 41.2211L20.8119 45.0336C21.127 45.2543 21.5681 45.1912 21.8202 44.876L23.8681 42.0088L17.4405 37.3457L15.3611 40.2127Z",
    fill: "url(#paint1_linear_423_400)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1592 30.7074C43.7496 30.2977 43.1509 30.1404 42.5838 30.3294L37.8891 31.9048V32.2199C37.8577 33.6063 36.8808 34.772 35.5575 35.0872L35.2423 35.1503C33.5094 35.5599 31.7135 35.812 29.9492 35.9065L28.4997 36.001C28.0272 36.0324 27.6175 35.6544 27.5861 35.1819C27.5547 34.7093 27.9327 34.2996 28.4052 34.2683L29.8547 34.1737C31.5246 34.0792 33.2261 33.8272 34.8644 33.4491L35.1795 33.386C35.7466 33.2601 36.1562 32.756 36.1879 32.1572C36.1879 31.8107 36.062 31.4641 35.8413 31.2436C35.5892 30.9915 35.2743 30.8656 34.9277 30.834L27.2713 30.7395C26.4522 30.7395 25.6014 30.9916 24.9397 31.4957L18.7012 36.1896L25.3178 40.9788L31.7454 41.483C32.8482 41.5775 33.9508 41.2309 34.8331 40.5063L44.0963 32.9759C44.4429 32.6924 44.6319 32.3142 44.6633 31.8731C44.6319 31.432 44.4742 31.0224 44.1592 30.7074Z",
    fill: "url(#paint2_linear_423_400)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_423_400",
    x1: 42.5224,
    y1: 21.574,
    x2: 27.1452,
    y2: 21.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_423_400",
    x1: 23.8673,
    y1: 41.2181,
    x2: 14.782,
    y2: 41.2181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_423_400",
    x1: 44.6609,
    y1: 35.821,
    x2: 17.3531,
    y2: 35.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005887"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceScore);
export default __webpack_public_path__ + "static/media/insuranceScore.41f2ece221a5edf6b5676e3c6b85e204.svg";
export { ForwardRef as ReactComponent };